import React from 'react'
import BeeswaxTag from './beeswaxTag'

const DemoStepThanks = props => {
    return (
        <div className="step content">
            <div className="demo-header">Thanks!</div>
            <p className="about-user">
                Thanks for reaching out! We'll be in touch soon
            </p>
            <BeeswaxTag />
        </div>
    )
}

export default DemoStepThanks
